
export default {
    isLogged: state => !!state.user,
    project: state => state.courseAndProject.project,
    course: state => state.courseAndProject.course,
    courseList: state => state.courseAndProject.courseList,
    showProjectEdit: state => state.courseAndProject.showProjectEdit,
    projectType: state => state.courseAndProject.projectType,
    showScenetEdit: state => state.courseAndProject.showScenetEdit,
    showPublishVersion: state => state.courseAndProject.showPublishVersion,
    taskInfo: state => state.task.checkTaskInfo,
    taskList: state => state.task.taskList,
    taskTotal: state => state.task.taskTotal,
    stepForm: state => state.task.currentStepForm,
    trigger: state => state.task.currentTrigger,
    stepList: state => state.task.currentStepList,
    sceneList: state => state.editor.sceneList,
    showMenu: state => state.courseAndProject.showMenu,
    showEditor: state => state.editor.show3dEditor,
    treeData: state => state.editor.treeData,
    treeDataMap: state => state.editor.treeDataMap,
    showSceneListDrawer: state => state.editor.showSceneListDrawer,
    showDefinition: state => state.editorDefinition.showDefinition,
    showType: state => state.editorType.showType,
    // 设备类型
    typeList: state => state.editorType.typeList,
    // 类型定义动作列表
    actionList: state => state.editorType.actionList,
    // 类型定义属性列表
    propList: state => state.editorType.propList,
    // 类型定义界面管理列表
    interfaceList: state => state.editorType.interfaceList,
    // 当前项目的序号
    currentProjectIndex: state => {
        const projectId = state.courseAndProject.project._id;
        return state.courseAndProject.course.children.findIndex(pro => pro._id === projectId) + 1;
    },
    // 选择的模型
    chooseModelList: state => state.editor.editorChooseModelArr,
    editorCameraPositionList: state => state.editor.cameraPositionList,
    permissions: state => state.permission.permissions,
    user: state => state.permission.user,
    isMobile:state => state.isMobile,
};
